<template>
    <!-- Navigation Dots -->
    <div class="nav">
        <div class="nav-dots">
            <div class="nav-dot active" data-section="0"></div>
            <div class="nav-dot" data-section="1"></div>
            <div class="nav-dot" data-section="2"></div>
            <div class="nav-dot" data-section="3"></div>
            <div class="nav-dot" data-section="4"></div>
        </div>
    </div>
    <!-- Hero Section -->
    <section class="hero flow-section">
        <div class="particles" id="particles"></div>
        <div class="hero-content">
            <h1>INOVARE</h1>
            <p>Where Innovation Meets Excellence</p>
        </div>
        <div class="scroll-indicator">
            <div class="scroll-arrow"></div>
            <p>Scroll to explore</p>
        </div>
    </section>
    <!-- Transition -->
    <div class="section-transition">
        <div class="transition-wave"></div>
    </div>
    <!-- About Section -->
    <section class="about-section flow-section">
        <div class="flow-content">
            <div class="about-grid">
                <div class="about-text">
                    <h2>Innovation Hub</h2>
                    <p>We are pioneers in creating extraordinary experiences that bring together brilliant minds from
                        across the globe. Our platform serves as a catalyst for innovation, entrepreneurship, and
                        transformative collaboration.</p>
                    <p>From virtual conferences to startup competitions, we craft events that inspire, educate, and
                        connect the next generation of innovators.</p>
                </div>
                <div class="floating-cards">
                    <div class="card">
                        <h3>🌍 Global Reach</h3>
                        <p>Connecting innovators worldwide through cutting-edge virtual platforms</p>
                    </div>
                    <div class="card">
                        <h3>🚀 Future-Ready</h3>
                        <p>Embracing tomorrow's technologies to create today's solutions</p>
                    </div>
                    <div class="card">
                        <h3>💡 Innovation First</h3>
                        <p>Every event designed to spark creativity and breakthrough thinking</p>
                    </div>
                    <div class="card">
                        <h3>🤝 Community Driven</h3>
                        <p>Building lasting connections between entrepreneurs and visionaries</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Transition -->
    <div class="section-transition">
        <div class="transition-wave"></div>
    </div>
    <!-- Achievements Section -->
    <section class="achievements-section flow-section">
        <div class="flow-content">
            <h2 style="text-align: center; font-size: 4rem; margin-bottom: 4rem; color: var(--luminous-coral);">Our
                Journey</h2>
            <div class="achievements-timeline">
                <div class="timeline-line"></div>
                <div class="achievement-item">
                    <div class="achievement-icon">🏆</div>
                    <div class="achievement-content">
                        <h3>Model United Nations Success</h3>
                        <p>Successfully hosted an immersive online Model United Nations debate competition that
                            captivated participants from around the world. Each attendee received beautifully crafted
                            personalized portraits as cherished mementos of their experience.</p>
                    </div>
                </div>
                <div class="achievement-item">
                    <div class="achievement-icon">🌟</div>
                    <div class="achievement-content">
                        <h3>Distinguished Leadership</h3>
                        <p>Honored to welcome two visionary entrepreneurs as our chief guests - one leading innovation
                            from Delhi's bustling startup ecosystem, and another pioneering change from Canada's tech
                            landscape.</p>
                    </div>
                </div>
                <div class="achievement-item">
                    <div class="achievement-icon">🚀</div>
                    <div class="achievement-content">
                        <h3>Innovation Ecosystem</h3>
                        <p>Created a thriving community where startups, students, and seasoned entrepreneurs converge to
                            share ideas, forge partnerships, and accelerate growth through meaningful connections.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Transition -->
    <div class="section-transition">
        <div class="transition-wave"></div>
    </div>
    <!-- Event Section -->
    <section class="event-section flow-section">
        <div class="flow-content">
            <div class="event-showcase">
                <h2 class="event-title">VenturioMUN</h2>
                <p style="font-size: 1.5rem; opacity: 0.9; margin-bottom: 3rem;"> Not your regular debate. Not your average MUN.</p>
                <div class="price-display">
                    <span class="original-price">{{ strikedCurrencySymbol }}</span>
                    <span class="current-price">{{ currencySymbol }}</span>
                </div>
               <div class="event-details-grid">
    <div class="detail-card">
        <h3 style="color: var(--luminous-coral); font-size: 1.8rem; margin-bottom: 1rem;">📅 Format</h3>
        <p><strong>1-Day Challenge</strong><br /><br />
            Fast-paced. Idea-packed. <strong>An unforgettable experience.</strong>
        </p>
    </div>
    <div class="detail-card">
        <h3 style="color: var(--luminous-coral); font-size: 1.8rem; margin-bottom: 1rem;">👥 Participants</h3>
        <p>Open to solo visionaries or agile teams. High schoolers, college creators, and early-stage founders.</p>
    </div>
    <div class="detail-card">
        <h3 style="color: var(--luminous-coral); font-size: 1.8rem; margin-bottom: 1rem;">🎁 Perks</h3>
        <p>Receive printed certificates co-signed by Inovare and the University of Calgary.</p>
    </div>
</div>

                <a class="cta-button"
                    href="/MUNRegistration">
                    Register Now - {{ currencySymbol }} Only!
                </a>
            </div>
        </div>
    </section>
    <!-- Transition -->
    <div class="section-transition">
        <div class="transition-wave"></div>
    </div>
    <!-- Contact Section -->
    <section class="contact-section flow-section">
        <div class="flow-content">
            <div class="contact-content">
                <h2 style="font-size: 4rem; margin-bottom: 2rem; color: var(--luminous-coral);">Get In Touch</h2>
                <p style="font-size: 1.3rem; opacity: 0.9; margin-bottom: 4rem;">Ready to be part of the innovation
                    revolution? Let's connect and create something extraordinary together.</p>
                <div class="contact-info">
                    <div class="contact-item">
                        <div class="contact-icon">📧</div>
                        <h3>Email Us</h3>
                        <p>team.inovare@gmail.com</p>
                        <a class="cta-button" href="mailto:team.inovare@gmail.com" style="margin-top: 1rem;"
                            target="_blank">Send Message</a>
                    </div>
                    <div class="contact-item">
                        <div class="contact-icon">🌐</div>
                        <h3>Follow Us</h3>
                        <p>Stay updated with our latest events</p>
                        <div
                            style="display: flex; gap: 1.5rem; justify-content: center; margin-top: 1rem; align-items: center;">
                            <a href="https://www.instagram.com/inovare.io/" onmouseout="this.style.transform='scale(1)'"
                                onmouseover="this.style.transform='scale(1.2)'"
                                style="color: var(--luminous-coral); font-size: 2rem; transition: transform 0.3s ease;"
                                target="_blank">
                                <svg fill="currentColor" height="32" viewbox="0 0 24 24" width="32">
                                    <path
                                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z">
                                    </path>
                                </svg>
                            </a>
                            <a href="https://www.linkedin.com/company/inovare-io/"
                                onmouseout="this.style.transform='scale(1)'"
                                onmouseover="this.style.transform='scale(1.2)'"
                                style="color: var(--luminous-coral); font-size: 2rem; transition: transform 0.3s ease;"
                                target="_blank">
                                <svg fill="currentColor" height="32" viewbox="0 0 24 24" width="32">
                                    <path
                                        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z">
                                    </path>
                                </svg>
                            </a>
                        </div>
                    </div>
                    <div class="contact-item">
                        <div class="contact-icon">💼</div>
                        <h3>Partnership</h3>
                        <p>Collaborate with us</p>
                        <a class="cta-button" href="mailto:team.inovare@gmail.com" style="margin-top: 1rem;"
                            target="_blank">Send Message</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'HomeView',
    created() {
        fetch('https://ipapi.co/json/')
        .then(response => response.json())
        .then(data => {
            console.log(data.country);
            if (data.country === "IN") {
            this.currencySymbol = '₹149';
            this.strikedCurrencySymbol = "₹500";
            } else {
            this.currencySymbol = '$25';
            this.strikedCurrencySymbol = "$39";
            }
        })
        .catch(err => {
            console.error("Geo API failed", err);
        });
    },
    data() {
        return {
            strikedCurrencySymbol: '$35',
            currencySymbol: '$25'
        }
    },
    mounted() {

        const hero = document.querySelector('.hero');
        if (!hero) return;
        let mouseX = 0, mouseY = 0;

        hero.addEventListener('mousemove', (e) => {
            mouseX = e.clientX / window.innerWidth;
            mouseY = e.clientY / window.innerHeight;

            hero.style.background = `radial-gradient(circle at ${mouseX * 100}% ${mouseY * 100}%, rgba(139, 92, 246, 0.2) 0%, var(--primary-dark) 70%)`;
        });

    }
}
</script>

<style scoped>
.flow-section {
    padding: 4rem 1rem !important;
}
</style>